import React, { memo } from 'react'
import 'scss/5_components/_info-message.scss'

interface IInfoMessageProps {
  cta?: boolean
  onDismissNotification: () => void
  message: string
  show: boolean
  theme: string
}

export const BookingInfoMessage = memo<IInfoMessageProps>(
  ({ cta, message, onDismissNotification, show, theme }) => {
    let setClass = `info vertically-center info-${theme} fixed`
    if (cta) setClass += ' info-cta'
    if (show) setClass += ' active'

    if (!cta && message) {
      setTimeout(() => {
        setClass = ''
        onDismissNotification()
      }, 3000)
    }
    if (!message || !show) return null

    return (
      <div className={setClass}>
        <div className='info-message'>
          <span>{message}</span>
        </div>
        {cta && (
          <span
            className='btn-text-link info-btn ttu fr'
            onKeyPress={onDismissNotification}
            onClick={onDismissNotification}
            role='button'
            tabIndex={0}>
            Dismiss
          </span>
        )}
      </div>
    )
  }
)
